import { FC } from "react"
import clsx from "clsx"

import { useTranslation } from "react-i18next"

export const RunsFiltersBar: FC<{
  loading: boolean
  query: string
  onQuery: (v: string) => void
  status: "" | "RUNNING" | "SUCCESS" | "FAILED"
  onStatus: (v: "" | "RUNNING" | "SUCCESS" | "FAILED") => void
  mode: "" | "BATCH" | "RULE"
  onMode: (v: "" | "BATCH" | "RULE") => void
  ruleId: string
  onRuleId: (v: string) => void
  ruleOptions: { id: string; name: string }[]
  onRefresh: () => void
}> = ({ loading, query, onQuery, status, onStatus, mode, onMode, ruleId, onRuleId, ruleOptions, onRefresh }) => {
  const { t } = useTranslation("translation", { useSuspense: false })
  const inputCls = clsx(
    "input input-bordered w-full md:w-[320px]",
    "bg-white dark:bg-[#0C0C1A]",
    "text-black dark:text-white",
    "border-[rgba(0,0,0,0.1)] dark:border-[rgba(255,255,255,0.1)]"
  )

  const selectCls = clsx(
    "select select-bordered w-full md:w-[180px]",
    "bg-white dark:bg-[#0C0C1A]",
    "text-black dark:text-white",
    "border-[rgba(0,0,0,0.1)] dark:border-[rgba(255,255,255,0.1)]"
  )

  return (
    <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between md:flex-wrap">
      <div className="flex flex-col gap-2 md:flex-row md:items-center md:flex-wrap">
        <input
          className={inputCls}
          placeholder={t("tags.searchByRuleError") as string}
          value={query}
          onChange={(e) => onQuery(e.target.value)}
        />

        <select className={selectCls} value={mode} onChange={(e) => onMode(e.target.value as any)}>
          <option value="">{t("form.allModes")}</option>
          <option value="BATCH">BATCH</option>
          <option value="RULE">RULE</option>
        </select>

        <select className={selectCls} value={status} onChange={(e) => onStatus(e.target.value as any)}>
          <option value="">{t("form.allStatuses")}</option>
          <option value="RUNNING">RUNNING</option>
          <option value="SUCCESS">SUCCESS</option>
          <option value="FAILED">FAILED</option>
        </select>

        <select
          className={clsx(
            "select select-bordered w-full md:w-[260px]",
            "bg-white dark:bg-[#0C0C1A]",
            "text-black dark:text-white",
            "border-[rgba(0,0,0,0.1)] dark:border-[rgba(255,255,255,0.1)]"
          )}
          value={ruleId}
          onChange={(e) => onRuleId(e.target.value)}
        >
          <option value="">{t("tags.allRules")}</option>
          {ruleOptions.map((r) => (
            <option key={r.id} value={r.id}>
              {r.name}
            </option>
          ))}
        </select>
      </div>

      <div className="flex gap-2">
        <button className={clsx("btn btn-sm", { "btn-disabled": loading })} onClick={onRefresh}>
          {t("common.refresh")}
        </button>
      </div>
    </div>
  )
}
